export type ModalType = 'email_confirmation';

export type ModalStep = 'set_password';

export type ModalScreen = {
  modalOpenId: string;
  modalStep?: ModalStep;
  modalType: ModalType;
};

export type ModalProperties = {
  modal_open_id: string;
  modal_step?: ModalStep;
  modal_type: ModalType;
};

export function toModalProperties({
  modalOpenId,
  modalStep,
  modalType
}: ModalScreen): ModalProperties {
  return {
    modal_open_id: modalOpenId,
    modal_step: modalStep,
    modal_type: modalType
  };
}
